import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { Response } from '../../../../_shared/models';
import { delay } from '../../../../_shared/helpers/delay.helper';
import { environment } from '../../../../../environments/environment';
import { Technician, TECHNICIANS_MOCK } from '../mockdata/work-order-mock-data';
import { WorkOrderTechnician } from '../models/technician.model';

// Re-export Technician type for consumers
export { Technician } from '../mockdata/work-order-mock-data';

@Injectable({
  providedIn: 'root'
})
export class TechnicianService {
  private http: HttpClient = inject(HttpClient);

  constructor() { }

  /**
   * Get all technicians
   * TODO: To be replaced with actual HTTP call to backend API
   */
  async getTechniciansAsync(workOrderIds: number[], cancellation: Subject<void>): Promise<Response<WorkOrderTechnician[]>> {
    const request = { workOrderIds };
    return firstValueFrom(this.http.post<Response<WorkOrderTechnician[]>>(`${environment.apiEndpoint}/workorder/technicians`, request).pipe(takeUntil(cancellation)));
  }

  /**
   * Get available technicians only
   * TODO: To be replaced with actual HTTP call to backend API
   */
  async getAvailableTechniciansAsync(cancellation: Subject<void>): Promise<Response<Technician[]>> {
    await delay(300);

    const availableTechnicians = TECHNICIANS_MOCK.filter(t => t.isAvailable);
    return Promise.resolve({
      data: availableTechnicians
    } as Response<Technician[]>);

    // Uncomment when backend API is ready
    // return firstValueFrom(
    //   this.http.get<Response<Technician[]>>(`${environment.apiEndpoint}/technicians/available`).pipe(takeUntil(cancellation))
    // );
  }

  /**
   * Get technician by ID
   * TODO: To be replaced with actual HTTP call to backend API
   */
  async getTechnicianByIdAsync(id: number, cancellation: Subject<void>): Promise<Response<Technician | null>> {
    await delay(200);

    const technician = TECHNICIANS_MOCK.find(t => t.id === id) ?? null;
    return Promise.resolve({
      data: technician
    } as Response<Technician | null>);

    // Uncomment when backend API is ready
    // return firstValueFrom(
    //   this.http.get<Response<Technician>>(`${environment.apiEndpoint}/technicians/${id}`).pipe(takeUntil(cancellation))
    // );
  }
}